var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34.807,12.511l-3.488,12.077c-3.03-2.052-6.327-3.744-13.318-0.83l3.408-11.945l0.041-0.019C28.414,8.908,31.787,10.447,34.807,12.511z","key":0}),React.createElement("path",{"d":"M36.633,13.68l-3.447,11.943c3.028,2.069,6.383,3.718,13.365,0.805l3.324-11.643C42.76,17.24,39.66,15.731,36.633,13.68z","key":1}),React.createElement("path",{"d":"M35.387,10.337l3.441-11.964C35.8-3.688,32.442-5.344,25.454-2.424L22.011,9.59c2.775-1.153,4.969-1.682,6.806-1.666C31.604,7.942,33.563,9.102,35.387,10.337z","key":2}),React.createElement("path",{"d":"M40.643-0.369l-3.44,12.033c3.018,2.063,6.669,3.752,13.359,0.738L54,0.415C47.021,3.317,43.665,1.688,40.643-0.369z","key":3})]);
}

Windows.defaultProps = {"viewBox":"12 -12 48 48","width":"48px","height":"48px"};

module.exports = Windows;

Windows.default = Windows;
